import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import LayoutReducer from './LayoutReducer';
import SiteReducer from './SiteReducer';

export const history = createBrowserHistory();

export default {
    layout: LayoutReducer,
    site: SiteReducer,
    router: connectRouter(history),
};



// WEBPACK FOOTER //
// ./js/reducers/index.js